export class FederatedSyncStats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "namespaces",
            "baseName": "namespaces",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tables",
            "baseName": "tables",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "namespacesAdded",
            "baseName": "namespacesAdded",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "namespacesRemoved",
            "baseName": "namespacesRemoved",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tablesAdded",
            "baseName": "tablesAdded",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tablesUpdated",
            "baseName": "tablesUpdated",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tablesRemoved",
            "baseName": "tablesRemoved",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "skipped",
            "baseName": "skipped",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "skippedByReason",
            "baseName": "skippedByReason",
            "type": "{ [key: string]: number; }",
            "format": "int64"
        },
        {
            "name": "missing",
            "baseName": "missing",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FederatedSyncStats.attributeTypeMap;
    }
    constructor() {
    }
}
